import { createContext, useContext } from "react";
import { useServiceStatusQuery } from "../lib/query/queries/useServiceStatusQuery";

const ServiceAvailabilityContext = createContext(null);

export function useServiceAvailability() {
  const context = useContext(ServiceAvailabilityContext);
  if (!context) {
    throw new Error("useServiceAvailability must be used within a ServiceAvailabilityProvider");
  }
  return context;
}

export function ServiceAvailabilityProvider({ children }) {
  const { data, isLoading } = useServiceStatusQuery();

  // While loading (or if the poll ever fails) default to open so a
  // network hiccup never blocks checkout on its own — the server-side
  // gate in mzito-pay is the actual authority.
  const value = {
    isOpen: data?.isOpen ?? true,
    opensAt: data?.opensAt ?? null,
    closesAt: data?.closesAt ?? null,
    timezone: data?.timezone ?? null,
    isLoading,
  };

  return (
    <ServiceAvailabilityContext.Provider value={value}>
      {children}
    </ServiceAvailabilityContext.Provider>
  );
}
